// State
export const state = () => ({
  vipTiers: {},
  vipSystem: {},
  vipSystemLoading: false,
  vipTiersLoading: false,
  isVipTierStatusActive: false
})

// Actions
export const actions = {
  async getVipTiers({ commit }, params) {
    commit('setVipTiersLoading', true)
    await this.$axios
      .get('/vip-system', { params })
      .then(data => {
        if (!this.$cookie.get('token') && data?.data) {
          // Set default player info for non-logged-in users
          const tiers = data?.data?.tiers.filter(el => el.tier_type === 1)
          data.data.player = {
            condition_type: data?.data?.player?.condition_type,
            total_amount: 0,
            current_tier: {
              name: {
                ...tiers[0]?.name
              },
              id: tiers[0]?.id,
              file: tiers[0]?.file
            }
          }
        }
        commit('setVipTiers', data?.data)
      })
      .catch(_ => {
        return false
      })
    commit('setVipTiersLoading', false)
  },
  async getVipSettings({ commit }, params) {
    commit('setVipSystemLoading', true)
    await this.$axios
      .get('/vip-system/settings', { params, headers: { 'Cache-Control': 'no-cache' } })
      .then(data => {
        commit('setVipSystem', data?.data)
        commit('setIsVipTierStatusActive', data?.data?.status === 1)
      })
      .catch(_ => {
        return false
      })
    commit('setVipSystemLoading', false)
  },
  async claimLevelUpReward({ dispatch }, tierId) {
    const response = await this.$axios
      .put(`/vip-system/claim/levelup?tier_id=${tierId}`, {})
      .then(data => {
        dispatch('player/totalBalance', {}, { root: true })
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async claimBirthdayReward({ dispatch }, tierId) {
    const response = await this.$axios
      .put(`/vip-system/claim/birthday?tier_id=${tierId}`, {})
      .then(data => {
        dispatch('player/totalBalance', {}, { root: true })
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  }
}

// Mutations
export const mutations = {
  setVipTiers: (state, data) => {
    state.vipTiers = data
  },
  setVipSystem: (state, data) => {
    state.vipSystem = data
  },
  setVipTiersLoading: (state, data) => {
    state.vipTiersLoading = data
  },
  setVipSystemLoading: (state, data) => {
    state.vipSystemLoading = data
  },
  setIsVipTierStatusActive: (state, data) => {
    state.isVipTierStatusActive = data
  }
}
